var _path, _circle;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8948 9.45143C17.7519 9.26821 14.3455 5 10.0009 5C5.65635 5 2.24996 9.26821 2.1052 9.45143C2.03683 9.53843 2 9.64326 2 9.75085C2 9.85844 2.03683 9.96327 2.1052 10.0503C2.24996 10.2318 5.65635 14.5 10.0009 14.5C14.3455 14.5 17.7519 10.2318 17.8948 10.0503C17.9632 9.96327 18 9.85844 18 9.75085C18 9.64326 17.9632 9.53843 17.8948 9.45143ZM10.0009 13.4821C6.83457 13.4821 4.08051 10.6847 3.25044 9.75C4.07867 8.81357 6.82724 6.01786 10.0009 6.01786C13.1746 6.01786 15.9213 8.81527 16.7514 9.75C15.9232 10.6864 13.1746 13.4821 10.0009 13.4821Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 2.5,
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eyeOpen.fcfeaab4f49efa39eb2d6758eade4c74.svg";
export { ForwardRef as ReactComponent };